<template>
    <div>
       <div class="container rublos_cedula mt-4">
            <!--<h4 class="font-weight-400">Nombre del trámite: {{cedula.nombre}}</h4> Esto solo es temporal para tener una referencia del tramite---->
            <!-- {{cedula}} -->
            <h4>Descripción del Trámite:</h4>
            <p v-html="cedula.descripcion"></p>
            <div id="accordion">
                <!-- ¿Qué necesito saber acerca del trámite? -->
                <div class="card">
                    <div class="card-header pl-0" id="headingOne">
                    <h5 class="mb-0">
                        <button class="btn btn-link btn-block text-left collapsed d-flex justify-content-between pl-0" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                            <span class="titulo_rublo">¿Qué necesito saber acerca del trámite?</span>
                            <span class="descargar" style="font-size:1.5rem;"><i class='bx bx-chevron-down icono-down' style="color: #560f2c;"></i></span>
                        </button>                        
                    </h5>
                    </div>

                    <div id="collapseOne" class="collapse" aria-labelledby="headingOne" data-parent="#accordion">
                    <div class="card-body">
                        <p class="titulo_campo">Fundamento Jurídico</p>
                        <p class="contenido_campo" v-html="cedula.fundamento_legal"></p>

                        <p class="titulo_campo">Casos en los que se debe o puede realizarse el Trámite/Servicio</p>
                        <p class="contenido_campo" v-html="cedula.casos_puede"></p>

                        <p class="titulo_campo">¿El Trámite/Servicio requiere Inspección o Verificación?</p>                       
                        <div v-for="(inspeccion, index) in cedula.se_requiere_Inspección" :key="index" class="inspeccion_verificacion">
                            <p class="contenido_campo" v-html="inspeccion"></p>                          
                        </div>

                        <p class="titulo_campo">Plazo que tiene el sujeto obligado para resolver el Trámite</p>
                        <p class="contenido_campo">{{cedula.plazo}}</p>

                        <p class="titulo_campo">Monto de derechos</p>
                        <p class="contenido_campo">{{cedula.monto}}</p>

                        <p class="titulo_campo">Adicional al monto de derechos del Trámite/Servicio</p>
                        <p class="contenido_campo">{{cedula.forma_costo}}</p>

                        <p class="titulo_campo">Forma de determinar el monto de derechos del Trámite/Servicio</p>
                        <!-- Si no existe la tabla de costos imprimir el No aplica -->
                        <div v-if="this.cedula.tabla_costo === '<p>\r\n\tNo aplica</p>\r\n' || this.cedula.tabla_costo === '<p>\r\n\tNo aplica.</p>\r\n' ">
                            <p class="contenido_campo">No aplica</p>
                        </div>
                        <!-- De lo contrario imprimir la tabla de costo -->
                        <div v-else>
                            <table id="costo" class="table table-bordered"></table> 
                        </div>

                        <p class="titulo_campo">Alternativas para realizar el pago</p>
                        <p class="contenido_campo" v-html="cedula.Realizar_pago"></p>

                        <p class="titulo_campo">Vigencia de la operatividad del Trámite/Servicio</p>
                        <p class="contenido_campo" v-html="cedula.vigencia_solicitud"></p>

                        <p class="titulo_campo">Resolución obtenida</p>
                        <p class="contenido_campo">{{cedula.vigencia}}</p>

                        <p class="titulo_campo">Vigencia de la resolución obtenida</p>
                        <p class="contenido_campo">{{cedula.vigencia_resolucion}}</p>

                        <p class="titulo_campo">Horario de Atención</p>
                        <p class="contenido_campo">{{cedula.horario}}</p>

                        <div v-if="cedula">
                            <p class="titulo_campo">Quejas y Sugerencias</p>
                            <p class="contenido_campo" v-html="cedula.quejas_y_sugerencias.intro"></p>
                            <div v-for="(organo, o) in cedula.quejas_y_sugerencias.listado_organos" :key="o" class="organo_quejas">
                                <p class="titulo_organo" style="font-weight: 500;">{{organo.Organo}}</p>
                                <p>Dirijase con: {{organo.Funcionario}}, sita en {{organo.domicilio}}, C.P. {{organo.cp}}</p>
                                <p>O bien, si lo prefiere comuníquese al Conmutador: {{organo.conmutador}}</p>                            
                            </div>
                            <p class="contenido_campo" v-html="cedula.quejas_y_sugerencias.final"></p>
                        </div>

                        <p class="titulo_campo">Información que establezca la normatividad aplicable</p>
                        <p class="contenido_campo" v-html="cedula.normatividad"></p>

                        <p class="titulo_campo">Información adicional</p>
                        <p v-html="cedula.adicionalinfo" class="info_adicional contenido_campo"></p>


                         

                         
                      
                    </div>
                    </div>
                </div>
                <!-- ¿Qué necesito para realizar este trámite? -->
                <div class="card">
                    <div class="card-header pl-0" id="headingTwo">
                    <h5 class="mb-0">
                        <button class="btn btn-link btn-block text-left d-flex justify-content-between pl-0" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                        <span class="titulo_rublo">¿Qué necesito para realizar este trámite?</span>
                        <span class="descargar" style="font-size:1.5rem;"><i class='bx bx-chevron-down icono-down' style="color: #560f2c;"></i></span>
                        </button>
                    </h5>
                    </div>
                    <div id="collapseTwo" class="collapse" aria-labelledby="headingTwo" data-parent="#accordion">
                    <div class="card-body">
                        <p class="titulo_campo">Requisitos</p>
                        <!-- Si el campo requisito esta vacio, no hay tabla -->
                        <div v-if="cedula.requisitos === ' ' ">
                            <p class="contenido_campo">No hay requisitos</p>
                        </div>
                        <!-- De lo contrario imprimir la tabla de requisitos -->
                        <div v-else>
                            <div class="contenedor-tablaRequisitos mb-5">
                                <table id="requisitos" class="table table-bordered table-condensed" ></table>
                            </div>
                        </div>

                        <p class="titulo_campo">Formatos</p>
                        <!-- Si no existe la tabla imprimir el NO aplica-->
                        <div v-if="objetoFto.formatos === 'No aplica'">
                            <p class="contenido_campo" v-html="objetoFto.formatos"></p>
                        </div>
                        <!-- De lo contrario imprimir la tabla -->
                        <div v-else>
                            <table id="formatos" class="table table-bordered"></table>
                        </div>
                    
                        <p class="titulo_campo">Criterios de resolución del Trámite/Servicio</p> 
                        <p class="contenido_campo" v-html="cedula.criterios"></p>
                    </div>
                    </div>
                </div>
                <!-- ¿Cómo y dónde puedo realizar este trámite? -->
                <div class="card">
                    <div class="card-header pl-0" id="headingThree">
                    <h5 class="mb-0">
                        <button class="btn btn-link btn-block text-left d-flex justify-content-between pl-0" data-toggle="collapse" data-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                        <span class="titulo_rublo">¿Cómo y dónde puedo realizar este trámite?</span> 
                        <span class="descargar" style="font-size:1.5rem;"><i class='bx bx-chevron-down icono-down' style="color: #560f2c;"></i></span>
                        </button>
                    </h5>
                    </div>
                    <div id="collapseThree" class="collapse" aria-labelledby="headingThree" data-parent="#accordion">
                    <div class="card-body">
                        <p class="titulo_campo">Cómo realizar el Trámite/Servicio</p>
                        <div v-if="cedula">
                            <p class="contenido_campo" v-html="cedula.indicaciones.intro_indicacion"></p>
                            <p v-html="cedula.indicaciones.indicacion" class="indicaciones ml-4"></p>                            
                        </div>

                        <!-- NOTA AQUI FALTAN EL CAMPO DE ABAJO -->
                        <p class="titulo_campo">Sujeto obligado responsable del trámite o servicio</p>
                        <!-- Si el campo cedula.donde_acudir.listado es un string imprimir el texto -->
                        <div v-if="cedula && typeof cedula.donde_acudir.listado === 'string'">
                            <p class="contenido_campo" v-html="cedula.donde_acudir.listado"></p>
                        </div>
                        <!-- De lo contrario el campo es un arreglo (array) con un listado de organos -->
                        <div v-else>
                            <!-- Si ese array tiene 1 solo elemento imprimirlo -->
                            <div v-if="cedula && cedula.donde_acudir.listado.length <= 1">
                                <div v-for="(delegacion, j) in cedula.donde_acudir.listado" :key="j">
                                    <div class="organos_info mt-3">
                                        <p style="font-weight: 500;">{{delegacion.Organo}}</p>
                                        <p>{{delegacion.Funcionario}}</p>
                                        <p>{{delegacion.domicilio}} C.P. {{delegacion.cp}} {{delegacion.municipio}}, {{delegacion.estado}}</p>
                                        <p>Conmutador:{{delegacion.conmutador}} Teléfono: {{delegacion.telefonodirecto}}</p>
                                        <p v-if="delegacion.Correo">Correo: {{delegacion.Correo}}</p>
                                    </div>
                                </div>                                                    
                            </div>
                            <!-- Si tiene más de 1 elemento imprimir esa lista en el select -->
                            <div v-else>
                                <!-- Area del select y el boton de consulta de los organos (donde acudir) -->
                                <div class="contSelect_organos d-flex justify-content-around">                            
                                    <select class="js-example-basic-single text-center" id="listaDelegaciones"></select>                           
                                    <button @click="obtenerDelegacionHacienda" class="btn btn-vino consultar_delegacion">Consultar</button>                           
                                </div> 
                            </div>       
                        </div>                                                                     
                        <!-- Aqui se imprime los detalles de la delegación seleccionada -->
                        <div v-if="detalleDelegación">
                            <div v-for="(v1, indice) in cedula.donde_acudir" :key="indice">
                                <div v-for="(delegacion, i) in v1" :key="i">
                                    <div v-if="delegacion.Organo == delegacionSeleccionada" class="organos_info ml-5 mt-3">
                                        <p style="font-weight: 500;">{{delegacion.Organo}}</p>
                                        <p>{{delegacion.Funcionario}}</p>
                                        <p>{{delegacion.domicilio}} C.P. {{delegacion.cp}} {{delegacion.municipio}}, {{delegacion.estado}}</p>
                                        <p>Conmutador:{{delegacion.conmutador}} Teléfono: {{delegacion.telefonodirecto}}</p>
                                        <p v-if="delegacion.Correo">Correo: {{delegacion.Correo}}</p>
                                    </div>
                                    
                                </div>
                            </div>
                        </div>

                    </div>
                    </div>
                </div>
            </div>           
        </div>
    </div>
</template>
<script>
import axios from "axios"
export default {
    data:function() {
        return{
            dataCedula: null,
            idTramite: this.$route.params.idTramite, //id del tramite
            token: this.$route.params.token,
            jsonCedula: "",
            verDetalleTramite: false,
            cedula: '',
            dataLimpia: '',
            varRespuesta: '',
            objetoFto: {},
            //datos para el select
            detalleDelegación: false,
            delegacionSeleccionada:''
            
            
        }
    },
    mounted(){
        
    },
    created: function(){
           console.log(this.idTramite, "holiwis");
           this.obtenerCedula(this.idTramite);
            
    },
    methods:{
        escapeRegExp(string) {
            return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); 
        },
        llenarSelect(_combo){
            var lista_delegaciones = this.cedula.donde_acudir
            $("#" + _combo).empty();
            $("#" + _combo).append(" <option hidden selected>Selecciona una delegación de Hacienda más cercana</option>");           
            // console.log(this.cedula.donde_acudir);
            for (let v1 in lista_delegaciones) {              
                // console.log(lista_delegaciones[v1]);         
                lista_delegaciones[v1].forEach(function(delegacion, index){
                     $("#" + _combo).append("<option value='" + delegacion.Organo + "'>" + delegacion.Organo + "</option>");
                });      
                
                
            }
        },
        obtenerDelegacionHacienda(){
            this.detalleDelegación = true;
            this. delegacionSeleccionada = document.getElementById('listaDelegaciones').value;
            console.log(this.delegacionSeleccionada)

        },
        obtenerCedula(cedula){
            var ced = cedula;
            var urlCedula   = 'http://api.retys.chiapas.gob.mx/cedula?token=';     

            //(validacion) opcion predeterminada seteada.
            if(ced == 'Ej. Baja de placas de demostración'){ ced = '3418' }

            axios.post(urlCedula + this.token, {
                idcedula: ced
            })
            .then(response => {
                this.cedula = response.data                
                // //***********Imprimiendo la tabla de costos
                var contCosto = this.cedula.tabla_costo; // Se guarda la respuesta de la tabla de costos
                var parrafo = '<p>'; //variable con el texto que imprime el parrafo en la parte de abajo 
                var parrafo2 = '<p style="text-align: center;">' //segundo parrafo que se imprime en la parte de abajo
                var r = new RegExp(this.escapeRegExp(parrafo),'g'); // Aplicar la función para agregar la palabra que se va a cambiar              
                var cost = contCosto.replace(r, '<p class="d-none">');  // le aplicamos esa etiqueta <p> un class d-none para que no se imprima                
                var r2 = new RegExp(this.escapeRegExp(parrafo2),'g'); // Aplicar la función para agregar el segundo parrafo que se va a cambiar              
                var costos = cost.replace(r2, '<p class="d-none">');  // le aplicamos esa etiqueta <p> un class d-none para que no se imprima
                document.getElementById('costo').innerHTML = costos; //imprimos esa tabla sin el parrafo vacio de hasta abajo
                
                // //**********Imprimiendo la tabla de requisitos: 
                var contenidoReq = this.cedula.requisitos //Guardando la respuesta de la tabla requisitos                
                var imagen = '<img src="../img/Ok_vd.png">'; //variable con el texto que imprime la imagen
                var re = new RegExp(this.escapeRegExp(imagen),'g'); // Aplicar la función para agregar la palabra que se va a cambiar
                var requisitos = contenidoReq.replace(re, '<i class="fas fa-check-circle" style="font-size:30px">');  // Aplicar reemplazo
                document.getElementById("requisitos").innerHTML = requisitos; //Se imprime la tabla de requisitos
               

                // //**********Imprimiendo la tabla de formatos:
                var contFormatos = this.cedula.formatos.formatos; //Guardando la respuesta de la tabla de formatos
                this.objetoFto = this.cedula.formatos
                document.getElementById('formatos').innerHTML = contFormatos //Se imprime la tabla de formatos

                this.llenarSelect('listaDelegaciones'); //le paso la id del select para que lo llene con los datos
                })
            .catch(function (error) {
                console.log(error);
            });

        },
        
        
    }
}
</script>
<style scoped>
.rublos_cedula{
        height: 100%;
        margin-bottom: 12rem;
}
.rublos_cedula h4{
    font-weight: 400;
}
.rublos_cedula p{
    font-weight: 400;
}
/* estilos collapse */
.rublos_cedula .card{
    border: none;
}
.rublos_cedula .card-header{
    background-color: #ffffff;
    border: 2px solid #fff;
    border-bottom: 1px solid #cbcbcb78 !important;
    border-radius: 0 !important;
}
.rublos_cedula .btn:focus, .btn:hover{
    /* Estilos para quitar el bordeado azul y el subrayado cuando el collapse esta activo (focus) 
    quitandole el subrayado del texto cuando se hace hover */
    box-shadow: none;
    text-decoration: none;
}
.rublos_cedula .btn{
    font-weight: 300;
    color: #212529;
    font-size: 17px;
}

.rublos_cedula .titulo_rublo{
    font-size: 20px;
    color: #5f5f71;
    font-weight: 500;
}
.rublos_cedula .titulo_campo {
    font-weight: 500;
    font-size: 19px;
    line-height: 19px;
    color: #4a4a56;
}
.rublos_cedula .contenido_campo{
    margin-left: 15px;
}
.rublos_cedula .organo_quejas p, .organos_info p{
    line-height: 26px;
    margin-bottom: 0px;
    margin-left: 2.5rem;
}

.rublos_cedula .indicaciones{
    /* color: red; */
    line-height: 30px;
}




/*  */

.contenedor-tablaRequisitos{
    /* Para que la tabla de requisitos quede en un contenedor con un scroll */
    width: 100%;
    height: 25rem;
    overflow: scroll;
    
}
/* Select */
.rublos_cedula #listaDelegaciones{
    width: 70%;
    border-radius: 5px;
    border: 1px solid #d9d4d4;
    font-size: 17px;
    color: #4e4a4a;
    padding: .5rem;
}
.rublos_cedula .consultar_delegacion {
    font-weight: 400;
    font-size: 17px;
    width: 20%;
}


/* estilos para movil */
@media only screen and (max-device-width : 1024px){
    /* Para que la tabla de requisitos quede en un contenedor con un scroll */
    .contenedor-tablaRequisitos{        
        overflow: scroll
    }   
}

</style>